import React from 'react';
export const Nav31DataSource = {
  wrapper: { className: 'header3 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header3-logo',
    children: 'https://yljx-oss.irematch.com/PicGo/组 4.png',
  },
  Menu: {
    className: 'header3-menu',
    children: [
      {
        name: 'item~kewkas353hm',
        className: 'header3-item',
        children: {
          href: 'https://www.yinghecloud.com/',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <p>首页</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
          target: '',
        },
      },
      {
        name: 'item0',
        className: 'header3-item',
        children: {
          href: '',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>
                                      <a href="#">社区团购</a>
                                    </p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
          target: '',
        },
        subItem: null,
      },
      {
        name: 'item2',
        className: 'header3-item',
        children: {
          href: 'https://www.yinghecloud.com/e-commerce/Fresh',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>生鲜配送</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
          target: '_blank',
        },
        subItem: null,
      },
      {
        name: 'item3',
        className: 'header3-item',
        children: {
          href: 'https://www.yinghecloud.com/research',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>零售商学院</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
          target: '_blank',
        },
      },
      {
        name: 'item~kel41cmty7s',
        className: 'header3-item',
        children: {
          href: 'https://www.yinghecloud.com/contact#checked-0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>
                                  <a
                                    href="https://www.yinghecloud.com/contact#checked-0"
                                    target="_blank"
                                  >
                                    联系我们
                                  </a>
                                </p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
          target: '_blank',
        },
      },
    ],
  },
  mobileMenu: { className: 'header3-mobile-menu' },
};
export const Banner51DataSource = {
  wrapper: { className: 'home-page-wrapper banner5 ke594j6w4gf-editor_css' },
  page: { className: 'home-page banner5-page ke594c5i1qc-editor_css' },
  childWrapper: {
    className: 'banner5-title-wrapper',
    children: [
      {
        children: (
          <span>
            <p>社区团购系统</p>
          </span>
        ),
        className: 'banner5-title ke5grqpbfc-editor_css',
        name: 'title',
      },
      {
        children: (
          <span>
            <p>爆品接龙+分销+秒杀+拼团+会员制电商</p>
          </span>
        ),
        className: 'banner5-explain',
        name: 'explain',
      },
      {
        children: (
          <span>
            <p>为每一个商户提供全方位系统支持+整套落地解决方案</p>
          </span>
        ),
        className: 'banner5-content',
        name: 'content',
      },
      {
        children: {
          children: (
            <span>
              <span>
                <p>申请免费试用</p>
              </span>
            </span>
          ),
          className: 'banner5-button ke596903feo-editor_css',
          href: 'https://www.yinghecloud.com/contact#checked-0',
          type: 'primary',
          target: '_blank',
        },
        className: 'banner5-button-wrapper',
        name: 'button',
      },
    ],
  },
  image: {
    className: 'banner5-image ke594v6886-editor_css',
    children:
      'https://yljx-oss.irematch.com/PicGo/千库网_卡通立体城市群_元素编号12839946 3.png',
  },
};
export const Feature12DataSource = {
  wrapper: {
    className: 'home-page-wrapper content1-wrapper kel0ydcxnlk-editor_css',
  },
  OverPack: {
    className: 'home-page content1 kewl8s77z2s-editor_css',
    playScale: 0.3,
  },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      'https://yljx-oss.irematch.com/PicGo/1eff491913c2d4f0e9eac2afe455b2eb.png',
    className: 'kel0yoww7sc-editor_css',
  },
  textWrapper: {
    className: 'content1-text kel0zqtdk57-editor_css',
    md: 14,
    xs: 24,
  },
  title: {
    className: 'content1-title kel110tso8c-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>什么是社区团购？</p>
            </span>
          </span>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content1-content kel10sk9cw-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>
                                <span>
                                  <br />
                                </span>
                              </p>
                              <p>
                                <span>
                                  社区团购就是真实居住社区内居民团体的一种购物消费行为，是依托真实社区的一种区域化、小众化、本地化的团购形式,是经过实践确认行之有效的一种新零售落地方案。
                                </span>
                              </p>
                              <p>
                                <span>
                                  <br />
                                </span>
                              </p>
                              <p>
                                通过社区团长为周围（社区内）居民提供
                                的团购形式的优惠活动，促进团长对核心客户的精准化宣传和消费刺激以及客情关系维护。
                              </p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
export const Banner40DataSource = {
  wrapper: { className: 'home-page-wrapper banner4 kel1q2frzq-editor_css' },
  page: { className: 'home-page banner4-page kel1oytp73c-editor_css' },
  childWrapper: {
    className: 'banner4-title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>社区团购流程图</p>
          </span>
        ),
        className: 'banner4-title kel1usl5tit-editor_css',
      },
    ],
  },
  image: {
    className: 'banner4-image kel1pr1cwgt-editor_css',
    children: 'https://yljx-oss.irematch.com/PicGo/社区团购 2.png',
  },
};
export const Content30DataSource = {
  wrapper: {
    className: 'home-page-wrapper content3-wrapper kewkhlv633-editor_css',
  },
  page: { className: 'home-page content3 ke5970gf47-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper kewkllrk8me-editor_css',
    children: [
      {
        children: (
          <span>
            <span>
              <p>为什么要做社区团购小程序？</p>
            </span>
          </span>
        ),
        className: 'title-h1',
        name: 'title',
      },
      {
        children: (
          <span>
            <p>最具潜力的社区电商模式，投入低，起步快，市场大</p>
          </span>
        ),
        className: 'title-content ke5fi0kixa8-editor_css',
        name: 'content',
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        children: {
          content: {
            children: (
              <span>
                <span>
                  <p>先收款后采购，轻松实现0库存0风险运作，损耗更低</p>
                </span>
              </span>
            ),
            className: 'content3-content ke5fixqxe4-editor_css',
          },
          icon: {
            children: 'https://yljx-oss.irematch.com/PicGo/预售信确认.png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <span>
                  <p>预售模式</p>
                </span>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block0',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <span>
                  <p>源头直采、社区直供，无中间环节抬价，利润空间大</p>
                </span>
              </span>
            ),
            className: 'content3-content ke5fj8qsm5c-editor_css',
          },
          icon: {
            children: 'https://yljx-oss.irematch.com/PicGo/采购 (1).png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <p>直采直供</p>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block1',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <p>以社区为单位配送，用户自提，解决最后100米物流成本</p>
              </span>
            ),
            className: 'content3-content ke5fjc1189-editor_css',
          },
          icon: {
            children: 'https://yljx-oss.irematch.com/PicGo/配送.png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <span>
                  <p>集中配送</p>
                </span>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block2',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <span>
                  <p>借助社区团长，基于熟人关系快速建群，低成本大量获客</p>
                </span>
              </span>
            ),
            className: 'content3-content ke5fjkg3fh7-editor_css',
          },
          icon: {
            children:
              'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <p>社交获客</p>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block3',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <p>以微信群形式，0距离0成本维护用户，粘性好复购率高</p>
              </span>
            ),
            className: 'content3-content ke5fjhroqnc-editor_css',
          },
          icon: {
            children: 'https://yljx-oss.irematch.com/PicGo/社群 (3).png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <p>社群聚合</p>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block4',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <p>平台自有的高频流量池，可延伸多种增值业务，前景无限</p>
              </span>
            ),
            className: 'content3-content ke5fjeype0o-editor_css',
          },
          icon: {
            children: 'https://yljx-oss.irematch.com/PicGo/提现申请 (3).png',
            className: 'content3-icon',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            children: (
              <span>
                <span>
                  <p>流量变现</p>
                </span>
              </span>
            ),
            className: 'content3-title',
          },
        },
        className: 'content3-block',
        md: 8,
        name: 'block5',
        xs: 24,
      },
    ],
  },
};
export const Teams10DataSource = {
  wrapper: {
    className: 'home-page-wrapper teams1-wrapper kewkodabco9-editor_css',
  },
  page: { className: 'home-page teams1 kewkmzj22yn-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>解决不同角色实际需求</p>
                </span>
              </span>
            </span>
          </span>
        ),
        name: 'title',
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        className: 'block',
        md: 8,
        name: 'block0',
        titleWrapper: {
          children: [
            {
              children:
                'https://yljx-oss.irematch.com/PicGo/千库网_商务白领办公讨论会议记录资料_摄影图编号80132 2.png',
              className: 'teams1-image ke3z286ha99-editor_css',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <p>社区团购企业客户</p>
                  </span>
                </span>
              ),
              className: 'teams1-title ke144ziogds-editor_css',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <p>整合供货商，培养社区团长</p>
                  </span>
                </span>
              ),
              className: 'teams1-job',
              name: 'content',
            },
            {
              children: (
                <span>
                  <p>
                    平台通过上游供货渠道培养和管理自己的社区团长，通过后台统一上传商品、处理订单、结算。
                  </p>
                  <p>
                    通过数据化分析和需求定制进行订单的匹配，把单量合理分配至各个管辖区的团长。
                  </p>
                </span>
              ),
              className: 'teams1-content ke146fp6euq-editor_css',
              name: 'content1',
            },
          ],
        },
        xs: 24,
      },
      {
        className: 'block',
        md: 8,
        name: 'block1',
        titleWrapper: {
          children: [
            {
              children:
                'https://yljx-oss.irematch.com/PicGo/千库网_挑选零食的女孩_摄影图编号93878.png',
              className: 'teams1-image ke3z2g0ovtp-editor_css',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>团长（社区合伙人）</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'teams1-title ke149a1mw2-editor_css',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <p>社群分享商品，佣金结算便捷</p>
                  </span>
                </span>
              ),
              className: 'teams1-job',
              name: 'content',
            },
            {
              children: (
                <span>
                  <p>
                    通过建立社区微信群来增加用户黏性和下单率，团长可通过小程序或微商城形式一键分享图文商品，推广更简单。
                  </p>
                  <p>
                    订单动态追踪，物流配送、提货随时提醒，佣金可随时一键提现，结算流程简单。
                  </p>
                </span>
              ),
              className: 'teams1-content ke14a8w0as-editor_css',
              name: 'content1',
            },
          ],
        },
        xs: 24,
      },
      {
        className: 'block',
        md: 8,
        name: 'block2',
        titleWrapper: {
          children: [
            {
              children:
                'https://yljx-oss.irematch.com/PicGo/千库网_秋天上海_摄影图编号92927.png',
              className: 'teams1-image ke3z2jb3uwh-editor_css',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>周边居民（用户）</p>
                </span>
              ),
              className: 'teams1-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>购买实惠方便，售后有保障</p>
                </span>
              ),
              className: 'teams1-job',
              name: 'content',
            },
            {
              children: (
                <span>
                  <p>
                    可以通过团购小程序或微商城直达商品购买页，缩短用户决策时间，体验好，成单率高。
                  </p>
                  <p>
                    商品从源头采购，价格实惠，性价比高。基于邻里关系，商品售后服务有保障，下单更放心。
                  </p>
                </span>
              ),
              className: 'teams1-content ke14bnpo68c-editor_css',
              name: 'content1',
            },
          ],
        },
        xs: 24,
      },
    ],
  },
};
export const Feature40DataSource = {
  wrapper: {
    className: 'home-page-wrapper content6-wrapper kewknto7i5e-editor_css',
  },
  OverPack: { className: 'home-page content6 kel65iobit-editor_css' },
  textWrapper: {
    className: 'content6-text ke14mkaftgl-editor_css',
    xs: 24,
    md: 10,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        children: (
          <span>
            <p>社区团购优势</p>
          </span>
        ),
        className: 'title-h1',
        name: 'title',
      },
      {
        children: (
          <span>
            <span>
              <p>盈和软件助您快速起步，做大做强！</p>
            </span>
          </span>
        ),
        className: 'title-content ke5fik332b8-editor_css',
        name: 'content',
      },
    ],
  },
  img: {
    children:
      'https://yljx-oss.irematch.com/PicGo/60e1ca6da3ff4da42cd115b7d3c2e56f.png',
    className: 'content6-img ke43vhvfa9-editor_css',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        content: {
          children: (
            <span>
              <span>
                <span>
                  <p>邻里熟人关系推荐提升成交率和复购率</p>
                </span>
              </span>
            </span>
          ),
          className: 'content6-content',
        },
        img: {
          children: 'https://yljx-oss.irematch.com/PicGo/信任名单.png',
          className: 'content6-icon',
        },
        name: 'block0',
        title: {
          children: (
            <span>
              <p>信任背书</p>
            </span>
          ),
          className: 'content6-title',
        },
      },
      {
        content: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <p>
                      社区的生鲜水果本身就拥有高频购买率，加上社区邻里间的消费场景，是非常高频的消费场景口
                    </p>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-content',
        },
        img: {
          children: 'https://yljx-oss.irematch.com/PicGo/购买 (2).png',
          className: 'content6-icon',
        },
        name: 'block1',
        title: {
          children: (
            <span>
              <span>
                <p>高频购买</p>
              </span>
            </span>
          ),
          className: 'content6-title',
        },
      },
      {
        content: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          基于微信小程序，百度小程序，美团小程序，支付宝、APP等
                          全触点营销
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-content',
        },
        img: {
          children: 'https://yljx-oss.irematch.com/PicGo/点击 (1).png',
          className: 'content6-icon',
        },
        name: 'block2',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>触点营销</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-title',
        },
      },
      {
        content: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <p>基于真实LBS小区，用户 识别度高和区域精准渗入</p>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-content',
        },
        img: {
          children: 'https://yljx-oss.irematch.com/PicGo/定位.png',
          className: 'content6-icon',
        },
        name: 'block3',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>流量精准</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-title',
        },
      },
      {
        content: {
          children: (
            <span>
              <span>
                <span>
                  <p>
                    通过团长维护好客群，小区用户间相互推荐，商品的周转率高且品质优质，将拥有超高的留存率
                  </p>
                </span>
              </span>
            </span>
          ),
          className: 'content6-content',
        },
        img: {
          children: 'https://yljx-oss.irematch.com/PicGo/推荐 (1).png',
          className: 'content6-icon',
        },
        name: 'block4',
        title: {
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <p>客情营销</p>
                  </span>
                </span>
              </span>
            </span>
          ),
          className: 'content6-title',
        },
      },
    ],
  },
};
export const Content50DataSource = {
  wrapper: {
    className: 'home-page-wrapper content5-wrapper kel5zp0znh-editor_css',
  },
  page: { className: 'home-page content5 kel5mph6c8r-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        children: (
          <span>
            <span>
              <p>为社区团购行业创业者专属打造</p>
            </span>
          </span>
        ),
        className: 'title-h1 kel60mtdhkt-editor_css',
        name: 'title',
      },
      {
        children: (
          <span>
            <p>社区多人拼团、社区裂变分销，轻松打造社区团购体系！</p>
          </span>
        ),
        className: 'title-content kewm3cnhrk9-editor_css',
        name: 'content',
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 16,
    children: [
      {
        children: {
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>首页</p>
                    </span>
                  </span>
                </span>
              </span>
            ),
            className: 'ke42yd13mqk-editor_css',
          },
          img: {
            children: 'https://yljx-oss.irematch.com/PicGo/WechatIMG396.png',
            className: 'ke3yx402zp9-editor_css',
          },
          wrapper: { className: 'content5-block-content' },
        },
        className: 'block',
        md: 6,
        name: 'block0',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <span>
                  <p>商品详情</p>
                </span>
              </span>
            ),
          },
          img: {
            children:
              'https://yljx-oss.irematch.com/PicGo/Snipaste_2020-09-02_17-07-46.png',
            className: 'ke3zjo79c5a-editor_css',
          },
          wrapper: { className: 'content5-block-content' },
        },
        className: 'block',
        md: 6,
        name: 'block1',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <p>秒杀活动</p>
              </span>
            ),
          },
          img: {
            children: 'https://yljx-oss.irematch.com/PicGo/秒杀列表页.png',
            className: 'ke41thcw83-editor_css',
          },
          wrapper: { className: 'content5-block-content' },
        },
        className: 'block',
        md: 6,
        name: 'block2',
        xs: 24,
      },
      {
        children: {
          content: {
            children: (
              <span>
                <p>团长中心</p>
              </span>
            ),
          },
          img: {
            children: 'https://yljx-oss.irematch.com/PicGo/WechatIMG397.png',
            className: 'ke41u3p8avq-editor_css',
          },
          wrapper: { className: 'content5-block-content' },
        },
        className: 'block',
        md: 6,
        name: 'block3',
        xs: 24,
      },
    ],
  },
};
export const Feature70DataSource = {
  wrapper: { className: 'home-page-wrapper feature7-wrapper' },
  page: { className: 'home-page feature7' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper',
    children: [
      {
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>为什么选择盈和软件社区团购解决方案？</p>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'feature7-title-h1',
        name: 'title',
      },
      {
        children: (
          <span>
            <p>300+项功能，精准匹配，高效交付，助你玩转社区团购</p>
          </span>
        ),
        className: 'feature7-title-content',
        name: 'content',
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper',
    gutter: 24,
    children: [
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/店铺 (1).png',
              className: 'feature7-block-image ke3lg1y5gu8-editor_css',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <p>团长小店</p>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>团长可选择平台商品上传到自己店铺，集中推广</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block0',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children:
                'https://yljx-oss.irematch.com/PicGo/直播 播放 摄像机 观看 面性 (2).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>直播卖货</p>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>直播带货+社区团购，双热门</p>
                  <p>模式驱动销量提升</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block1',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/城市 (1).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>城市代理</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>扩大平台品牌影响力，减轻平台本身运营多城市的投资风险</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block2',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/仓库 (1).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>前置仓模式</p>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          开启前置仓模式，分担平台压力，帮助平台更好地发展业务
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block3',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/区域资源.png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>区域商品展示</p>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>按不同城市显示商品，不限制</p>
                  <p>城市，个性化运营</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block4',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/分销 (1).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>三级分销</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <p>
                      通过注册获取分销权限，获得分销权益，借助平台货源快速获取销量
                    </p>
                  </span>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block5',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/WH爆品.png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>爆品模式</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>参与爆品接龙，一起团，转化新客户，提高复购率！</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block6',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/vip (1).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>会员制电商</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>
                    企业通过提高运营效率，主动降低商品毛利率，打造专属会员特权
                  </p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block7',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/爆品专区-领券.png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <p>营销活动</p>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          优惠券、拼团、秒杀、种草社区等<span>
                            营销插件助力
                          </span>
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block8',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/推荐 (2).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>千人千面</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        根据会员标签精准匹配展示商品、类目排序、小视频、文章等
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block9',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/员工.png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>员工管理</p>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>多用户，多角色管理，分工</p>
                  <p>协作，高效运营</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block10',
        xs: 24,
      },
      {
        children: {
          children: [
            {
              children: 'https://yljx-oss.irematch.com/PicGo/数据 (1).png',
              className: 'feature7-block-image',
              name: 'image',
            },
            {
              children: (
                <span>
                  <p>数据统计</p>
                </span>
              ),
              className: 'feature7-block-title',
              name: 'title',
            },
            {
              children: (
                <span>
                  <p>每日销量、团长佣金、利润分析</p>
                  <p>、生意参谋，智能化管理</p>
                </span>
              ),
              className: 'feature7-block-content',
              name: 'content',
            },
          ],
          className: 'feature7-block-group',
        },
        className: 'feature7-block',
        md: 6,
        name: 'block11',
        xs: 24,
      },
    ],
  },
};
export const Footer00DataSource = {
  wrapper: {
    className: 'home-page-wrapper footer0-wrapper kel39f2i5q-editor_css',
  },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright kel37fw93w6-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>
                <br />
              </p>
              <p>
                高新技术企业证书 | 软件企业证书 | 营业执照 | 犀游互动 商标注册证
                | 网络文化经营许可证 豫网文(2019)6091-207 |
                增值电信业务经营许可证 豫B2-20170211
              </p>
              <p>
                copyright © 2014-2019 郑州盈和软件技术有限公司 版权所有
                豫ICP备16031643号-1 软件企业编号：豫RQ-2018-0408
                公安部备案号：41019702002457
              </p>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
